import { Outlet, matchPath, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import styles from './statistics.module.css';
import { useHasPermission } from '../../../contexts/auth';

export const Statistics = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const canViewEquipmentGroups = useHasPermission("service.view_equipmentgroup");
  const canViewJobs = useHasPermission("service.view_job");

  const pathname = location.pathname;
  const basePath = "/service/statistics";
  const isDetailsRoute = Boolean(matchPath('/service/statistics/equipment-groups/:id', pathname))
    || Boolean(matchPath('/service/statistics/technicians/:id', pathname));

  const visibleTabs = [
    ...(canViewJobs ? [{ key: 'general-stats', path: `${basePath}/general-stats` }] : []),
    ...(canViewJobs ? [{ key: 'technicians', path: `${basePath}/technicians` }] : []),
    ...(canViewJobs ? [{ key: 'equipment-stats', path: `${basePath}/equipment-stats` }] : []),
    ...(canViewJobs ? [{ key: 'group-stats', path: `${basePath}/group-stats` }] : []),
    ...(canViewEquipmentGroups ? [{ key: 'equipment-groups', path: `${basePath}/equipment-groups` }] : []),
  ];

  if (visibleTabs.length === 0) {
    return null;
  }

  const getTabValue = () => {
    if (pathname.includes('/equipment-groups')) {
      const index = visibleTabs.findIndex(tab => tab.key === 'equipment-groups');
      return index >= 0 ? index : 0;
    }
    if (pathname.includes('/general-stats')) {
      const index = visibleTabs.findIndex(tab => tab.key === 'general-stats');
      return index >= 0 ? index : 0;
    }
    if (pathname.includes('/technicians')) {
      const index = visibleTabs.findIndex(tab => tab.key === 'technicians');
      return index >= 0 ? index : 0;
    }
    if (pathname.includes('/equipment-stats')) {
      const index = visibleTabs.findIndex(tab => tab.key === 'equipment-stats');
      return index >= 0 ? index : 0;
    }
    if (pathname.includes('/group-stats')) {
      const index = visibleTabs.findIndex(tab => tab.key === 'group-stats');
      return index >= 0 ? index : 0;
    }
    return 0;
  };

  return (
    <Box className={styles.container}>
      {!isDetailsRoute && (
        <Tabs
          className="subTabs"
          value={getTabValue()}
          variant="scrollable"
          scrollButtons="auto"
        >
          {visibleTabs.map((tab) => {
            const labels: Record<string, string> = {
              "general-stats": t("General Stats"),
              "equipment-groups": t("Equipment Groups"),
              "technicians": t("Technicians"),
              "equipment-stats": t("Equipment Stats"),
              "group-stats": t("Group Stats"),
            };
            return (
              <Tab
                key={tab.key}
                label={labels[tab.key]}
                onClick={() => navigate(tab.path)}
              />
            );
          })}
        </Tabs>
      )}
      <Box className={styles.content}>
        <Outlet />
      </Box>
    </Box>
  );
};
